import React from 'react'
import {connect} from 'react-redux'

import Component from '../components/deposit.jsx'
import actions from '../actions/deposit'
import {User as userActions} from '../../../state/actions'
import {push} from 'react-router-redux'

class Container extends React.Component {

  render() {
    return <Component {...this.props}/>
  }
}

Container.propTypes = {}

const mapStateToProps = state => {
  const data = state.ui.depositV2.deposit
  return {
    isLoggedIn: state.domain.user.token !== '',
    isOpen: data.get('isOpen'),
    flowStep: data.get('flowStep'),
    flowReset: data.get('flowReset'),
    flowLoading: data.get('flowLoading'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onClose: () => {
      dispatch(push({search: ''}))
      return dispatch(actions.setOpen(false))
    },
    setFlowStep: (flowStep) => dispatch(actions.setFlowStep(flowStep)),
    setFlowReset: (flowReset) => dispatch(actions.setFlowReset(flowReset)),
    setFlowLoading: (flowLoading) => dispatch(actions.setFlowLoading(flowLoading)),
    updateUserInfo: () => dispatch(userActions.updateUserInfo()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/depositV2/containers/deposit.js